/** 查询用户属性的类型 */
export var UserAttrType;
(function (UserAttrType) {
    /** 查询用户ekyc状态 */
    UserAttrType["ekyc"] = "ekyc";
    /** 查询用户是否已绑卡 */
    UserAttrType["bindCard"] = "card_bind";
})(UserAttrType || (UserAttrType = {}));
/** ekyc状态 */
export var EkycStatus;
(function (EkycStatus) {
    /** 已入金/ekyc审核通过 */
    EkycStatus["pass"] = "pass";
    /** 未提交 */
    EkycStatus["empty"] = "empty";
    /** 审核中 */
    EkycStatus["underReview"] = "underReview";
    /** 驳回中 */
    EkycStatus["rejected"] = "rejected";
})(EkycStatus || (EkycStatus = {}));
